module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright-t"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_vm._v("Copyright © Leo Bruce 1937")])]), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_c('p', {
    staticClass: "copyright"
  }, [_vm._v("First American Edition 1982 Academy Chicago")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Published by Academy Chicago")]), _vm._v(" "), _c('p', {
    staticClass: "copyright0"
  }, [_vm._v("425 North Michigan Ave.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright0"
  }, [_vm._v("Chicago, IL 60611")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Printed and bound in the U.S.A.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("First paperback edition 1982 Academy Chicago")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Library of Congress Cataloging in Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Bruce, Leo, 1903-1980.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-ind"
  }, [_vm._v("Case without a corpse.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-ind1"
  }, [_vm._v("Reprint. Originally published: London: G. Bles, 1937.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-ind"
  }, [_vm._v("I. Title")]), _vm._v(" "), _c('p', {
    staticClass: "copyright0"
  }, [_vm._v("PR6005.R673C38     1982     823’.912     82-3916")]), _vm._v(" "), _c('p', {
    staticClass: "copyright0"
  }, [_vm._v("ISBN 0-89733-052-8                                AACR2")]), _vm._v(" "), _c('p', {
    staticClass: "copyright0"
  }, [_vm._v("ISBN 0-89733-050-1 (pbk.)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15d98596","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/003_Copyright.vue
// module id = 66
// module chunks = 0